import React, { useState } from "react";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import styled from "styled-components";
const StylableEmailInput = React.forwardRef(({ children, className, tooltip, placeholder, onValueChange, disabled, name = "email", value, ...htmlProps }, ref) => {
    const [validity, setValidity] = useState(null);
    const handleChange = (e) => {
        if (ref != null && typeof ref !== "function") {
            setValidity(ref?.current?.validity.valid);
        }
        onValueChange?.(e.target.value);
    };
    return (React.createElement("div", { className: className, "data-testid": "email-field" },
        React.createElement("input", { type: "email", name: name, id: "email", title: tooltip, placeholder: placeholder, onChange: (e) => handleChange(e), pattern: "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$", disabled: disabled, ...htmlProps, "data-testid": "email-input", "data-valid": validity, "data-disabled": !!disabled, value: value, ref: ref }),
        children));
});
StylableEmailInput.defaultProps = {
    "data-testid": "email-field",
};
StylableEmailInput.displayName = "StylableEmailInput";
export const EmailInput = styled(StylableEmailInput) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=EmailInput.js.map